"use client";
import React from "react";
import Blog from "./_components/Blog";

const page = () => {
  return (
    <div className="bg-[#FFFFFF] flex flex-col items-center w-full">
      <div className="bg-[#FFFFFF] w-full ">
        <Blog />
      </div>
    </div>
  );
};
export default page;
